import React from 'react';

import { SideNavigationRef } from './side-navigation/side-navigation';
import { FirstBar, HamburgerContainer, SecondBar, ThirdBar } from './styles';

export interface HamburgerButtonProps {
  sideNavigationRef: React.RefObject<SideNavigationRef>;
}

export default function HamburgerButton(props: HamburgerButtonProps) {
  return (
    <HamburgerContainer
      onClick={() => {
        props.sideNavigationRef.current?.toggle();
      }}
    >
      <FirstBar $isActive={false} />
      <SecondBar $isActive={false} />
      <ThirdBar $isActive={false} />
    </HamburgerContainer>
  );
}
